// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { SearchGetString } from './types.generated'

const searchLocales = ['en-US'] as const

export const getString: SearchGetString = i18nBundle('search', searchLocales).getString

